var $f07280ca05544eb8$exports = {};
$f07280ca05544eb8$exports = {
    "clear": `Helder`,
    "invalid": `(ongeldig)`,
    "loading": `Laden...`,
    "noResults": `Geen resultaten`,
    "valid": `(geldig)`
};


export {$f07280ca05544eb8$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
